import moment from 'moment';

class Payment {
    public paymentTypeId: number;
    public paymentType?: string;
    public cardNumber?: string;
    public cardExpirationDate?: moment.Moment;
    public circuitId?: string;
    public circuit?: string;
    public iban?: string;
    public swift?: string;
    public recurring?: string;
    public accountSignatory?: string;
    public fiscalId?: string;
    public nationId: string;
    public nation?: string;
    public province?: string;
    public cityId?: string;
    public city?: string;
    public postalCode?: string;
    public address?: string;
    public accountHolder?: string;

    constructor(
        paymentTypeId?: number,
        paymentType?: string,
        cardNumber?: string,
        cardExpirationDate?: moment.Moment,
        circuitId?: string,
        circuit?: string,
        iban?: string,
        swift?: string,
        recurring?: string,
        accountSignatory?: string,
        fiscalId?: string,
        nationId?: string,
        nation?: string,
        province?: string,
        cityId?: string,
        city?: string,
        postalCode?: string,
        address?: string,
        accountHolder?: string
    ) {
        this.paymentTypeId = paymentTypeId || 1;
        this.paymentType = paymentType || undefined;
        this.cardNumber = cardNumber || undefined;
        this.cardExpirationDate = cardExpirationDate || undefined;
        this.circuitId = circuitId || undefined;
        this.circuit = circuit || undefined;
        this.iban = iban || undefined;
        this.swift = swift || undefined;
        this.recurring = recurring || undefined;
        this.accountSignatory = accountSignatory || undefined;
        this.fiscalId = fiscalId || undefined;
        this.nationId = nationId || 'IT';
        this.nation = nation || undefined;
        this.province = province || undefined;
        this.cityId = cityId || undefined;
        this.city = city || undefined;
        this.postalCode = postalCode || undefined;
        this.address = address || undefined;
        this.accountHolder = accountHolder || undefined;
    }
}

export default Payment;
